<template>
  <div class="basic_wrap">
    <div class="login_bg auth-header">
      <button
        type="button"
        class="auth-back"
        @click="$router.back()"
      >
        <van-icon name="arrow-left" />
      </button>
      <h1>{{ $t('login.login') }}</h1>
      <button
        type="button"
        class="language"
        @click="$router.push('/language')"
      >
        <img
          :src="require('../images/language/'+lang+'.png')"
          alt=""
        >
      </button>
    </div>
    <div class="login_logo">
      <img
        class="logo"
        src="../images/shop2/logo.png"
      >
    </div>
    <div class="form">
      <!--     <div class="cut_login">
                <router-link class="cur" to="/login"
                    >{{$t('login.signIn')}}
                    <div class="line"></div>
                </router-link>
                <router-link to="/register"
                    >{{$t('login.signUp')}}
                    <div class="line"></div>
                </router-link>
            </div> -->
      <div class="item mt">
        <span class="icon">
          <van-icon
            name="phone-o"
            size="25"
          />
        </span>
        <!-- <span class="area_code">
					+ 1
				</span> -->
        <!-- <input type="text" readonly="readonly" style="width: 50px;" class="area_code" value="+ 1"> -->
        <input
          v-model.trim="data.phone"
          type="tel"
          inputmode="numeric"
          maxlength="20"
          class="inp"
          :placeholder="$t('login.phoneNumber')"
        >
      </div>
      <div class="item">
        <span class="icon">
          <van-icon
            name="lock"
            size="25"
          />
        </span>
        <input
          v-model.trim="data.password"
          :type="password"
          class="inp"
          :placeholder="$t('login.password')"
        >
        <div
          class="eye_bi"
          :class="password == 'text' ? 'eye' : ''"
          @click="showPwd"
        />
      </div>
      <div class="item_reset_pwd">
        <van-checkbox
          v-model="checked"
          icon-size="14px"
        >
          {{ $t('login.remember') }}
        </van-checkbox>
        <!-- <router-link class="reset_pwd" to="/forgetpwd">{{$t('login.forget')}}</router-link> -->
      </div>
      <div
        type="submit"
        class="basic_btn sbtn"
        :class="
          data.phone == '' || data.password == '' ? 'no_touch' : ''
        "
        @click="submit"
      >
        {{ $t('login.login') }}
      </div>
			
      <div class="register">
        {{ $t('login.signUp') }}<router-link
          class="link flow"
          to="/register"
        >
          {{ $t('register.register') }}
        </router-link>
      </div>
    </div>
    
    <div
      v-if="msg_show"
      class="kefu"
      :class="show_kefu ? '' : 'kefu_hide'"
      @click="kefu_to"
    >
      <img
        class="kefu_img"
        src="../images/shop2/kefu.jpg"
      >
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Fetch from "../../utils/fetch"
import { Icon, Checkbox } from 'vant'
Vue.use(Checkbox).use(Icon);

export default {
    name: "Login",
    data() {
        return {
			lang:this.$i18n.locale||"zh_cn",
            password: "password",
            show_kefu: true,
            msg_show: true,
			checked: true,
			app:null,
            data: {
                phone: "",
                password: "",
            },
        };
    },
    created() {
        this.data.phone = localStorage.getItem('login_phone') || localStorage.getItem('login_username') || '';
        localStorage.removeItem('login_username');
        localStorage.removeItem('login_password');
        this.$parent.footer("user", false);
    },
    mounted() {
		document.body.addEventListener("scroll", this.hideKefuOnScroll, false);
		document.addEventListener("click", this.hideKefuOnOutsideClick, false);
		Fetch('/index/webconfig').then((r)=>{
			this.app = r.data;
		});
    },
    beforeDestroy() {
        document.body.removeEventListener("scroll", this.hideKefuOnScroll, false);
        document.removeEventListener("click", this.hideKefuOnOutsideClick, false);
    },
    methods: {
		hideKefuOnScroll() {
			this.show_kefu = false;
		},
		hideKefuOnOutsideClick(ev) {
			if (ev.target.className != "kefu_img") {
				this.show_kefu = false;
			}
		},
        kefu_to() {
            if (this.show_kefu) {
				// window.location.href=this.app.kefu_link;
				this.$router.push("/kefu2");
            }
            this.show_kefu = !this.show_kefu;
        },
        showPwd() {
            if (this.password == "password") {
                this.password = "text";
            } else {
                this.password = "password";
            }
        },
        submit() {
            if (!this.data.phone) {
                this.$toast(this.$t('login.phoneEmpty'));
                return;
            }

            if (!/^\d{6,20}$/.test(this.data.phone)) {
                this.$toast(this.$t('login.phoneError'));
                return;
            }

            if (!this.data.password) {
                this.$toast(this.$t('login.passwordEmpty'));
                return;
            }

			if(this.checked){
				localStorage.setItem('login_phone', this.data.phone);
			} else {
				localStorage.removeItem('login_phone');
			}
			localStorage.removeItem('login_password');

            Fetch("/index/login", {
                phone: this.data.phone,
                password: this.data.password
            })
                .then((res) => {
					if(res.data.token){
						localStorage.setItem('token', res.data.token);
					}
                    this.$toast({
                        background: "#07c160",
                        message: this.$t('login.signInSuccess'),
                    });
                })
                .then(() => {
                    // this.$router.replace({
                    //     path:
                    //         this.$router.history.current.query.redirect || "agree",
                    // });
					this.$router.replace({
						path:"index",
					});
                });
        },
    },
};
</script>

<style lang="less" scoped>
.login_bg {
    width: 100%;
    height: 48px;
    overflow: hidden;
    background: none;
    background-size: 100% 100%;
	position: relative;
	.language{
		position: absolute;
		top: 4px;
		right: 0;
		height: 36px;
		img{
			height: 100%;
		}
	}
}

.basic_wrap .form {
    margin: 0 auto ;
    width: 94%;
    height: 332px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 9px 2px rgba(160, 160, 160, 0.15);
    border-radius: 13px;
    padding: 0 8%;
	opacity: 0.85;
}

.cut_login {
    width: 207px;
    line-height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    text-align: center;
    margin: 0 auto;

    a {
        width: 50%;
        padding-bottom: 10px;
        color: #808080;
        position: relative;

        .line {
            width: 100%;
            height: 1px;
            position: absolute;
            left: 0;
            bottom: 0;
            background-color: #f2f2f2;
        }
    }

    a.cur {
        color: #D20100cc;

        .line {
            height: 2px;
            background-image: linear-gradient(to right, #f90, #f18a11);
        }
    }
}

.mt {
    margin-top: 20px;
}

.item {
    height: 68px;
    border-bottom: 1px solid #f0f1f3;
    font-size: 14px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    padding-bottom: 4px;

    .icon {
        width: 32px;
        height: 27px;

        img {
            height: 100%;
        }
    }

    input {
        height: 20px;
        margin-left: 7px;
        flex: 1;
        margin-bottom: 3px;
    }
}

.item_reset_pwd {
    font-size: 14px;
    color: green;
    text-align: right;
    margin-top: 10px;
    line-height: 20px;
}
.van-checkbox{
	margin-top: 20px;
}
.reset_pwd{
	color: #323233;
	margin-top: -20px;
	display: block;
}

.basic_btn {
    margin: 39px auto 0 auto;
	
	height: 45px;
	line-height: 45px;
	font-size: 16px;
	text-align: center;
	color: #fff;
	border: 10px;
	border-radius: 5px;
	background: linear-gradient( 147deg, rgb(113, 183, 255), rgb(23, 131, 252) 74% );
}
.big_tit{
	color: #000;
}
/deep/ .van-checkbox__icon--checked .van-icon {
    color: #fff;
    background-color: #D20100cc;
    border-color: #D20100cc;
}
/deep/ .van-icon {
  
}
.login_logo {
    width: 100%;
    color: #fff;
    text-align: center;
    -webkit-animation: bot_top-data .3s;
    animation: bot_top-data .3s;
	font-size: 16px;
	color: #333;
	font-weight: bold;
	margin-top: 10px;
}
.login_logo img {
    width: 25%;
	-webkit-animation: logobig-data .5s;
	animation: logobig-data .5s;
}
.form{
	-webkit-animation: bot_top-data .3s;
	animation: bot_top-data .3s;
}
@-webkit-keyframes bot_top-data {
    0% {
        margin-top: 1000px;
        opacity: 0;
    }
    100% {
        margin-top: 0;
        opacity: 1;
    }
}

@keyframes bot_top-data {
    0% {
        margin-top: 1000px;
        opacity: 0;
    }
    100% {
        margin-top: 0;
        opacity: 1;
    }
}
	.register{
		line-height: 30px;
		text-align: center;
		margin-top: 30px;
		font-size: 15px;
	}
	.basic_wrap {
		height: 100vh;
		max-width: 750px;
		background: url(../images/shop2/1.png) no-repeat top;
		background-size: 100% ;
		padding-bottom: 10%;
		background-color: #FFF;
		filter: opacity(80%);
		background-position: 50%;
		background-size: cover;
		display: inline-block;
		width: 100%;
		min-height: 100vh;
	}
	.area_code{
		font-size: 16px;
		line-height: 20px;
		padding: 5px;
	}
	/deep/ .van-checkbox__label{
		line-height: 20px;
		font-size: 14px;
		color: #000;
		font-weight: 700;
	}
	input{
		font-size: 14px;
		color: #000;
	}
	input::placeholder {
		font-size: 14px;
		color: #000;
		font-weight: 700;
	}
	.basic_btn{
		font-size: 18px;
	}
	.flow {
		color: red;
		font-weight: bolder;
		font-size: 16px;
	}

	.basic_wrap {
		min-height: 100vh;
		padding-bottom: 0;
		background: #fff;
		filter: none;
	}
	.login_bg.auth-header {
		display: flex;
		height: 50px;
		align-items: center;
		justify-content: center;
		border-bottom: 1px solid #f1f1f1;
		background: #fff;
	}
	.auth-header h1 {
		margin: 0;
		color: #222;
		font-size: 17px;
		font-weight: 500;
		line-height: 24px;
	}
	.auth-back,
	.language {
		position: absolute;
		top: 0;
		display: flex;
		width: 50px;
		height: 50px;
		align-items: center;
		justify-content: center;
		padding: 0;
		border: 0;
		background: transparent;
		color: #ee4d2d;
		font-size: 23px;
	}
	.auth-back { left: 0; }
	.language { right: 0; }
	.language img { width: 28px; height: 28px; object-fit: contain; }
	.login_logo {
		width: 100%;
		margin-top: 66px;
		text-align: center;
		-webkit-animation: none;
		animation: none;
	}
	.login_logo img {
		width: 64px;
		max-height: 76px;
		margin: 0;
		-webkit-animation: none;
		animation: none;
		object-fit: contain;
	}
	.form { -webkit-animation: none; animation: none; }
	.basic_wrap .form {
		width: auto;
		height: auto;
		min-height: 0;
		margin: 52px 29px 0;
		padding: 0;
		border-radius: 0;
		box-shadow: none;
		opacity: 1;
	}
	.mt { margin-top: 0; }
	.item {
		height: 64px;
		box-sizing: border-box;
		align-items: center;
		padding: 0 8px;
		border-bottom-color: #d9d9d9;
	}
	.item .icon {
		display: flex;
		width: 30px;
		height: 100%;
		align-items: center;
		justify-content: flex-start;
		color: #666;
	}
	.item input {
		height: 100%;
		margin: 0 0 0 10px;
		color: #333;
		font-size: 15px;
	}
	.item input::placeholder { color: #a8afb8; font-weight: 400; }
	.eye_bi { margin-left: 8px; opacity: .7; }
	.item_reset_pwd {
		margin-top: 14px;
		color: #555;
		text-align: left;
	}
	.van-checkbox { margin-top: 0; }
	/deep/ .van-checkbox__label { color: #555; font-size: 13px; font-weight: 400; }
	/deep/ .van-checkbox__icon--checked .van-icon { border-color: #ee4d2d; background-color: #ee4d2d; }
	.basic_btn,
	.basic_btn.sbtn {
		width: 100%;
		height: 44px;
		margin: 28px 0 0;
		border-radius: 4px;
		background: #ee4d2d;
		box-shadow: none;
		color: #fff;
		font-size: 15px;
		font-weight: 500;
		line-height: 44px;
	}
	.basic_btn.no_touch { background: #ededed; color: #a8afb8; }
	.register {
		margin-top: 28px;
		color: #666;
		font-size: 14px;
		line-height: 22px;
	}
	.flow { margin-left: 4px; color: #ee4d2d; font-size: 14px; font-weight: 500; }
</style>
